module.exports = __webpack_public_path__ + "static/media/GA_Feedback_2018.12.24.b002c525.webp";